var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Skeleton, Typography } from "@mui/material";
export function DashboardKpiCard(_a) {
    var card = _a.card;
    return (_jsxs(Box, __assign({ sx: {
            background: "#fff",
            borderRadius: "14px",
            border: "1px solid #ECEEF4",
            px: 2.5,
            py: 2,
            height: 164,
            width: "100%",
            boxSizing: "border-box",
        } }, { children: [_jsx(Box, __assign({ sx: {
                    width: 44,
                    height: 44,
                    borderRadius: "10px",
                    background: card.iconBg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 1.5,
                } }, { children: _jsx(card.Icon, { sx: { color: "#fff", fontSize: 22 } }) })), card.loading ? (_jsxs(_Fragment, { children: [_jsx(Skeleton, { variant: "text", width: "60%", height: 36, sx: { borderRadius: "6px", mb: 0.5 } }), _jsx(Skeleton, { variant: "text", width: "80%", height: 18, sx: { borderRadius: "4px", mb: 0.5 } }), _jsx(Skeleton, { variant: "text", width: "55%", height: 16, sx: { borderRadius: "4px" } })] })) : (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ sx: {
                            fontFamily: "Montserrat, sans-serif",
                            fontWeight: 800,
                            fontSize: { xs: "1.15rem", md: "1.4rem" },
                            color: "#1F2937",
                            lineHeight: 1.1,
                            mb: 0.45,
                            wordBreak: "break-word",
                        } }, { children: card.value })), _jsx(Typography, __assign({ sx: {
                            fontFamily: "Montserrat, sans-serif",
                            fontWeight: 600,
                            fontSize: "0.77rem",
                            color: "#6B7280",
                            lineHeight: 1.25,
                            mb: 0.35,
                        } }, { children: card.label })), _jsx(Typography, __assign({ sx: {
                            fontFamily: "Montserrat, sans-serif",
                            fontSize: "0.73rem",
                            color: card.detailColor,
                            fontWeight: 500,
                            lineHeight: 1.2,
                        } }, { children: card.detail }))] }))] })));
}
